import React from "react"
import PropTypes from "prop-types"
import moment from "moment"
import TypeDropdown from "./wrappers/TypeDropdown"
import DatePicker from "./wrappers/DatePicker"
import CompanyAutocomplete from "./wrappers/CompanyAutocomplete"
import LocationAutocomplete from "./wrappers/LocationAutocomplete"
import SelectField from "./wrappers/SelectField"
import ValueRange from "./wrappers/ValueRange"
import KeywordsAutocomplete from "./wrappers/KeywordsAutocomplete"
import { filterOptions, CUSTOM_DEADLINE } from "./filterConfig"
import { setValue } from "./useReducer/actionCreators"
import styles from "./index.module.scss"

const CoreFilters = ({ values, dispatch }) => {
  const set = (name) => (value) => dispatch(setValue(name, value))
  // Two columns, filled row by row in the design's order.
  return (
    <div className={styles.coreGrid}>
      <div className={styles.item}>
        <TypeDropdown
          selectedType={values.opportunityType}
          dispatch={dispatch}
        />
      </div>
      <div className={styles.item}>
        <SelectField
          id="filter_eligibility"
          label="Eligibility"
          options={filterOptions.eligibility}
          value={values.eligibility}
          onChange={set("eligibility")}
        />
      </div>
      <div className={styles.item}>
        <SelectField
          id="filter_industry"
          label="Industry / Sector"
          options={filterOptions.industry}
          value={values.industry}
          onChange={set("industry")}
        />
      </div>
      <div className={styles.item}>
        <CompanyAutocomplete
          companyInput={values.companyInput}
          externalDispatch={dispatch}
        />
      </div>
      <div className={styles.item}>
        <LocationAutocomplete
          locationInput={values.locationInput}
          externalDispatch={dispatch}
        />
      </div>
      <div className={styles.item}>
        <DatePicker
          fromDate={values.fromDate}
          toDate={values.toDate}
          onChangeFrom={set("fromDate")}
          onChangeTo={set("toDate")}
        />
      </div>
      <div className={styles.item}>
        <ValueRange
          min={values.valueMin}
          max={values.valueMax}
          onChangeMin={set("valueMin")}
          onChangeMax={set("valueMax")}
        />
      </div>
      <div className={styles.item}>
        <KeywordsAutocomplete
          value={values.keywords}
          onChange={set("keywords")}
        />
      </div>
      <div className={styles.item}>
        <SelectField
          id="filter_deadline"
          label="Application Deadline"
          options={filterOptions.deadline}
          value={values.deadline}
          onChange={set("deadline")}
        />
      </div>
      {values.deadline === CUSTOM_DEADLINE && (
        <div className={styles.item}>
          <DatePicker
            title="Deadline Range"
            fromDate={values.deadlineFrom}
            toDate={values.deadlineTo}
            minDate={moment().startOf("day")}
            maxDate={null}
            onChangeFrom={set("deadlineFrom")}
            onChangeTo={set("deadlineTo")}
          />
        </div>
      )}
    </div>
  )
}

CoreFilters.propTypes = {
  values: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
}

export default CoreFilters
